const stock = require('@/apps/stock/api/stock');

let api = {};
Object.assign(api, stock.default)

export default api;
